export default __webpack_public_path__ + "static/media/plus.2e76fef7.svg";